import {useMutation, useQuery} from "react-query";
import {getJSON, postJSON} from "../api/http";
import {endpoints} from "../api/endpoints";
import {useState} from "react";
import {LocalStorageService} from "../services/LocalStorageService";

const getRegulation = async () =>
    getJSON(endpoints.regulations);

const putUserChangePassword = () =>
    postJSON(endpoints.regulations, {})

export const useRegulation = (successCallback?: Function) => {
    const {setToken} = LocalStorageService(),
        [errors, setErrors] = useState<string[]>([]),

        {mutate} = useMutation(
            putUserChangePassword,
            {
                onSuccess: () => {
                    setToken('1', 'regulation')
                    if (successCallback) {
                        successCallback();
                    }
                },
                onError: (error: any) => {
                    setErrors(Object.values(error?.data.errors || {}));
                },
                onSettled: () => {
                },
            }
        ),

        {data, isLoading, error} = useQuery(
            "regulations",
            () => getRegulation(),
            {
                staleTime: Infinity,
            }
        );

    return {
        acceptRegulation: mutate,
        isLoading,
        data: data?.data,
        error,
        errors,
    };
};
